module.exports = __webpack_public_path__ + "img/IT0000478278943.e005bcdb.png";